import {BehaviorSubject, ReplaySubject, Subject} from "rxjs";
import {AppData} from "./app-entity.model";

export enum OrderingPhase {
    ORDERING,
    PAYMENT,
    COMPLETE
}

export class SessionEvents {

    /**
     * Sent by: SessionModel
     * Tracks changes to the current ordering phase.
     */
    public static readonly orderingPhase$: BehaviorSubject<OrderingPhase> = new BehaviorSubject(OrderingPhase.ORDERING);

    /**
     * Notifies the details of the current app config.
     */
    public static readonly currentApp$: Subject<AppData> = new ReplaySubject(1);
}



// WEBPACK FOOTER //
// ./src/app/orchestration/session-events.ts